module.exports = [{
      plugin: require('/home/gepeto/beemarketingmx/beemarketingmx-dunham/theme/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
